import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//services
import getCustomer from "../services/customers/getCustomer";
import getCustomerJobs from "../services/customers/getCustomerJobs";
import getCustomerPremises from "../services/customers/getCustomerPremises";

// fetch about customers
export const fetchCustomerProfile = createAsyncThunk(
  "customer/fetchProfile",
  getCustomer.handler,
);

export const fetchCustomerJobs = createAsyncThunk(
  "customer/fetchJobs",
  getCustomerJobs.handler,
);

export const fetchCustomerPremises = createAsyncThunk(
  "customer/fetchPremises",
  getCustomerPremises.handler,
);

const initialState = {  
  profile: null,
  jobs: [],
  premises: [],
  loading: false,
};

const slice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clearCustomerDetail: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerJobs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerJobs.fulfilled, (state, action) => {
        const jobs = action.payload?.items || [];
        // most recent first
        state.jobs = [...jobs].sort(
          (a, b) => new Date(b.created) - new Date(a.created),
        );
        state.loading = false;
      })
      .addCase(fetchCustomerPremises.fulfilled, (state, action) => {
        state.premises = action.payload || [];
      })
      .addCase(fetchCustomerJobs.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchCustomerProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
      })
      .addCase(fetchCustomerProfile.rejected, (state) => {
        state.profile = null;
      });
  },
});

export const { clearCustomerDetail } = slice.actions;
export default slice.reducer;
